<template>
  <svg width="24" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.48734 10.4036L5.00005 10.1317L4.51276 10.4036L1.05005 12.3359V1.93734C1.05005 1.74785 1.12386 1.57051 1.24833 1.44322C1.37205 1.31669 1.535 1.24984 1.70005 1.24984H8.30005C8.46509 1.24984 8.62805 1.31669 8.75177 1.44322C8.87623 1.57051 8.95005 1.74785 8.95005 1.93734V12.3359L5.48734 10.4036ZM8.95005 13.328C8.95005 13.3279 8.95005 13.3279 8.95005 13.3279V13.328ZM9.53738 13.3374L9.53134 13.334L9.53738 13.3374L9.54015 13.3389L9.53738 13.3374Z"
      stroke="#BA3B46"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: 'BookmarkOutlineSvg'
}
</script>

<style></style>
